<template>
    <div class="navigation-services-mobile">
        <div class="navigation__loader" v-if="loading || error">
            <LoadingIndicator />
        </div>
        <template v-if="!loading && !error">
            <div class="navigation-services-mobile__filters">
                <button class="navigation-services-mobile__filter-button"
                    :class="{ 'navigation-services-mobile__filter-button--active': activeService === index }"
                    v-for="(category, index) in services" :key="category.title" @click="toggleSection(index)">{{
                        category.title }}</button>
            </div>
            <div class="navigation-services-mobile__results"
                v-show="activeServices.services && activeServices.services.length > 0">
                <div class="navigation-services-mobile__links">
                    <template v-for="(service, index) in activeServices.services" :key="index">
                        <div class="navigation-services-mobile__link"
                            :class="{ 'navigation-services-mobile__link--active': activeParent === service.title }"
                            @click="service.children && service.children.length === 0 ? goToService(service.url) : toggleChildren(service)">
                            <span>{{ service.title }}</span>
                            <i class="icon-chevron-down" v-if="service.children && service.children.length > 0"></i>
                        </div>
                        <template v-for="(child, index) in service.children" :key="index">
                            <div v-if="activeParent === service.title" @click="goToService(child.url)"
                                class="navigation-services-mobile__link navigation-services-mobile__link--first-level">
                                <span>{{ child.title }}</span> <span class="locations-card__translations"
                                    style="margin-bottom: 0px" v-if="child.hasCulture">{{
                                        child.translationsAvailableLabel }}
                                </span>
                            </div>
                        </template>
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from "../../components/Global/LoadingIndicator.vue";

export default {
    components: {
        LoadingIndicator
    },
    data() {
        return {
            error: false,
            loading: true,
            services: [],
            activeService: null,
            activeServices: [],
            activeParent: null,
            activeChildren: [],
        }
    },
    mounted() {
        this.getServices();
    },
    computed: {
        slicedServices() {
            const res = [];
            let chunkSize = 6;
            for (let i = 0; i < this.activeChildren.length; i += chunkSize) {
                const chunk = this.activeChildren.slice(i, i + chunkSize);
                res.push(chunk);
            }
            return res
        }
    },
    methods: {
        goToService: function (url) {
            window.location.href = url;
        },
        toggleSection: function (key) {
            this.activeService = key;
            this.activeServices = this.services[key];
            this.activeChildren = [];
        },
        toggleChildren: function (service) {
            if (this.activeParent === service.title) {
                this.activeParent = null;
                this.activeChildren = [];
            } else {
                this.activeParent = service.title;
                this.activeChildren = service.children;
            }
        },
        getServices: function () {
            axios.post("/api/services?culture=en", null, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then((response) => {
                    this.services = response.data.categories
                    this.activeService = 0;
                    this.activeServices = this.services[0];
                    this.activeChildren = this.activeServices.services[0].children;
                    this.loading = false;
                })
                .catch((err) => {
                    this.error = true;
                    this.loading = false;
                });
        }
    }
}
</script>

